<mat-sidenav-container class="sidenav-container" #sidenav autosize>
    <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
        [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
        <ng-material-multilevel-menu [configuration]='_config' [items]='_appItems' />
    </mat-sidenav>
    <mat-sidenav-content>
        <mat-toolbar color="primary" class="toolbar-height">
            @if (isHandset$ | async) {
            <button type="button" aria-label="Toggle sidenav" mat-icon-button [disabled]="isLoggedIn == false"
                (click)="drawer.toggle()">
                <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
            </button>
            }
            <span>Register Your Personal Injury Claim</span>
        </mat-toolbar>
        <div class="outer-container">
            <div class="inner-container">
                <div class="inner-container-center">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>